import { CheckCircle, Cancel, ErrorOutline } from '@mui/icons-material';
import { Alert, AlertTitle, Box } from '@mui/material';
import PageHeader from '../Common/PageHeader';

const FeedbackWrapper = ({ children }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}
    >
        <PageHeader />
        <Box sx={{ m: 5, mt: 13, width: '100%', maxWidth: '1000px' }} />
        {children}
    </Box>
);
const FeedbackUnavailable = () => (
    <FeedbackWrapper>
        <Alert
            sx={{ fontSize: '1.1rem' }}
            severity="warning"
            icon={<ErrorOutline fontSize="large" />}
        >
            <AlertTitle fontSize="1.2rem">
                We are unable to identify this request.
            </AlertTitle>
            Please contact your agent to request a new review link.
        </Alert>
    </FeedbackWrapper>
);
const FeedbackCompleted = () => (
    <FeedbackWrapper>
        <Alert
            severity="success"
            sx={{ fontSize: '1.1rem' }}
            icon={<CheckCircle fontSize="large" />}
        >
            <AlertTitle fontSize="1.2rem">Thank you!</AlertTitle>
            Thank you for confirming your application. Your signature has been
            submitted.
        </Alert>
    </FeedbackWrapper>
);
const FeedbackCancelled = () => (
    <FeedbackWrapper>
        <Alert
            severity="warning"
            sx={{ fontSize: '1.1rem' }}
            icon={<Cancel fontSize="large" />}
        >
            <AlertTitle fontSize="1.2rem" paddingBottom={1}>
                This application has been cancelled by the agent.
            </AlertTitle>
            Please contact your agent to request a new application link.
        </Alert>
    </FeedbackWrapper>
);

export { FeedbackUnavailable, FeedbackCompleted, FeedbackCancelled };
